import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import api from "../../../config/URL";
import toast from "react-hot-toast";

function AffiliateView() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadIndicator, setLoadIndicator] = useState(false);

  const isActive = data?.active === 1 || data?.active === "1";

  const getData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`admin/account/${id}`);
      setData(response.data.data);
      setTransactionData(response.data.data.transactions);
    } catch (error) {
      toast.error("Error Fetching Data ", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [id]);

  const stripHtmlTags = (html) => {
    if (!html) return "";
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const handleToggleActiveStatus = async () => {
    setLoadIndicator(true);
    try {
      const res = await api.post(`admin/deactive-affiliate/${id}`);
      const { success, message } = res.data || {};

      if (success) {
        toast.success(message);
        setData((prev) => ({
          ...prev,
          active: prev.active === 1 || prev.active === "1" ? 0 : 1,
        }));
      } else {
        toast.error(message || "Something went wrong.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Server Error");
    } finally {
      setLoadIndicator(false);
    }
  };

  const navigate = useNavigate();
  const [transactionData, setTransactionData] = useState([]);

  const handleRowClick = (orderId, productId) => {
    navigate(`/order/view/${orderId}/${productId}`);
  };

  return (
    <section className="px-4">
      {loading ? (
        <div className="loader-container">
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <circle cx="40" cy="40" r="32"></circle>
            </svg>
          </div>
        </div>
      ) : (
        <>
          <div className="card shadow border-0 mb-3">
            <div className="row p-3">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <h3 className="ls-tight">View Affiliate</h3>
                </div>
                <div>
                  <button
                    type="button"
                    onClick={handleToggleActiveStatus}
                    className={`btn btn-sm me-2 ${
                      !isActive ? "btn-success" : "btn-danger"
                    }`}
                    disabled={loadIndicator}
                  >
                    {loadIndicator && (
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        aria-hidden="true"
                      ></span>
                    )}
                    {isActive ? "Deactivate" : "Activate"}
                  </button>
                  <Link to="/affiliate">
                    <button type="button" className="btn btn-light btn-sm me-2">
                      <span>Back</span>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div
            className="container card shadow border-0"
            style={{ minHeight: "80vh" }}
          >
            <div className="row mt-5 p-3">
              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Name</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.name || ""}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Email</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">: {data?.email || ""}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Bank Name</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.bank_name || ""}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Account Number</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.account_number || ""}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Account Holder Name</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.account_holder_name || ""}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Affiliate Percentage</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.affiliate_percentage || ""}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Affiliate Code</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.affiliate_code || ""}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">IFSC Code</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.ifsc_code}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Total Commission Earned</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.total_commission_earned}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Total Withdrawan</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.total_withdrawn || "-"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Outstanding Balance</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.outstanding_balance}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-12">
                <div className="row mb-3">
                  <div className="col-6 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Minimum Withdrawal</p>
                  </div>
                  <div className="col-6">
                    <p className="text-muted text-sm">
                      : {data?.affiliate_details?.minimum_withdrawal || "-"}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="row mb-3">
                  <div className="col-12 d-flex justify-content-start align-items-center">
                    <p className="text-sm">Affiliate Terms</p>
                  </div>
                  <div className="col-12">
                    <p className="text-muted text-sm">
                      {stripHtmlTags(data?.affiliate_details?.affiliate_terms)}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12">
                {transactionData.length > 0 ? (
                  <div className="table-responsive mt-4 ">
                    <h5 className="mb-3">Order Items</h5>
                    <table className="table table-bordered table-hover">
                      <thead className="custom-table-head">
                       <tr style={{ backgroundColor: "#ff0060" }}>
                          <th className="text-center text-white">S.NO</th>
                          <th className="text-center text-white">Item Number</th>
                          <th className="text-center text-white">Quantity</th>
                          <th className="text-center text-white">Unit Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {transactionData.map((data, index) => (
                          <tr
                            key={index}
                            onClick={() =>
                              handleRowClick(data.order_id, data.product_id)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <td className="text-center">{index + 1}</td>
                            <td className="text-center">{data.item_number}</td>
                            <td className="text-center">{data.quantity}</td>
                            <td className="text-center">
                              {data.unit_price
                                ? new Intl.NumberFormat("en-IN", {
                                    style: "currency",
                                    currency: "INR",
                                    maximumFractionDigits: 0,
                                  }).format(data.unit_price)
                                : "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="mt-5 px-3 py-5">
                    <p className="text-muted text-center">
                      No transaction available for this user.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
}

export default AffiliateView;
